import {getIn, useFormikContext} from "formik"
import {BaSeInput, BaSeOptionPicker} from "@base/react"
import InputNumber from "./input-number";
import InputPercentage from "./input-percentage";

export default function FormInput({
                                    name,
                                    label,
                                    placeholder,
                                    subLabel,
                                    onExternalChange,
                                    onExternalBlur,
                                    type = "text",
                                    options = [],
                                    maxLength = 22,
                                    allowNegative = false,
                                    maxValue = 100,
                                    background = "",
                                    barColor = "",
                                    ...props
                                  }) {
  const {
    values,
    handleChange,
    errors,
    touched,
    setFieldTouched,
    setFieldValue,
  } = useFormikContext()

  const rawValue = getIn(values, name)
  const value = rawValue === undefined || rawValue === null ? "" : String(rawValue)
  const error = getIn(errors, name)
  const isTouched = getIn(touched, name)
  const inputStatus = isTouched ? (error ? "invalid" : "valid") : ""

  const handleInputChange = (e) => {
    if (["currency"].includes(type)) {
      const normalized = e === "" || e === null || e === undefined ? 0 : e
      setFieldValue(name, normalized)
      return
    }

    handleChange(e)
  }
  const handleInputBlur = (e) => {
    handleChange(e)
    setFieldTouched(name, true)

    let newValue = e.target.value

    if (type === "number") {
      const numericValue = parseInt(newValue, 10)
      const finalValue = isNaN(numericValue) ? 0 : numericValue
      setFieldValue(name, finalValue)
      if (onExternalChange) {
        onExternalChange(name, finalValue)
      }
      if (onExternalBlur) {
        onExternalBlur(name, finalValue)
      }
      return
    }

    if (onExternalChange) {
      onExternalChange(name, newValue)
    }
    if (onExternalBlur) {
      onExternalBlur(name, newValue)
    }
  }
  const handleSelectChange = (selectedValues) => {
    const selectedId = selectedValues.map((val) => val.id)[0] ?? ""
    setFieldValue(name, selectedId)
    if (onExternalChange) {
      onExternalChange(name, selectedId)
    }
  }
  const handleNumberChange = (numericValue) => {
    setFieldValue(name, numericValue)
  }
  const handlePercentageChange = (numericValue) => {
    setFieldValue(name, numericValue)
  }

  const wrapperClass = (base) => `${base} ${inputStatus}`
  const baseInputProps = {
    name,
    value,
    onBlur: handleInputBlur,
    label,
    placeholder,
    subLabel,
    inputStatus,
    size: "medium",
    width: "100%",
    ...props,
  }

  return (
    <>
      {type === "text" && (
        <div className={wrapperClass("wrapper-input")}>
          <BaSeInput
            {...baseInputProps}
            onInput={handleInputChange}
            inputMode="text"
            typeInput="text"
            maxLength={maxLength}
          />
        </div>
      )}

      {type === "number" && (
        <InputNumber
          {...baseInputProps}
          maxLength={maxLength}
          maxValue={maxValue}
          allowNegative={allowNegative}
          onFnExternalChange={handleNumberChange}
        />
      )}

      {type === "currency" && (
        <div className={wrapperClass("wrapper-input")}>
          <BaSeInput
            {...baseInputProps}
            onChange={handleInputChange}
            placeholder={placeholder || "R$ 0,00"}
            inputMode="decimal"
            typeInput="tel"
            mask="decimal"
            prefix="R$ "
            maxLength={maxLength}
          />
        </div>
      )}

      {type === "percentage" && (
        <InputPercentage
          {...baseInputProps}
          maxLength={maxLength}
          maxValue={maxValue}
          allowNegative={allowNegative}
          onFnExternalChange={handlePercentageChange}
          onFnExternalBlur={handlePercentageChange}
        />
      )}

      {type === "select" && (
        <div className={wrapperClass("wrapper-select") + (value ? " has-value" : "")}>
          <BaSeOptionPicker
            label={label}
            subLabel={subLabel}
            values={options}
            enableSelectAll={false}
            menuAlwaysIsOpen={false}
            withFilterText={false}
            emptyValueLabel={placeholder || "Selecione"}
            maxOptionsSelected={1}
            initialSelectedValuesId={value ? [value] : []}
            onChange={handleSelectChange}
            onBlur={() => setFieldTouched(name, true)}
            {...props}
          />
        </div>
      )}
    </>
  )
}
